








































































































































































import {Component, Ref, Vue} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import {FormRowWings, SelectWings, FieldTooltip, InputWings} from "wings-ui-components";
import {cloneDeep, isEqual} from "lodash";
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {AddressBookContactItem} from "@/store/addressbooks/types";
import { getTranslatedParams } from "@/utils/notify-utils";
import { ActionLog } from "@/store/auth/types";

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({components: {FormRowWings, SelectWings, FieldTooltip, InputWings}})
export default class AddressBookContact extends Vue {
  @Ref('validator') validator:any;
  @Getter("addressBookContacts") addressBookContactsResponse: any;
  @Getter("addressBookItem") addressBookItem: any;
  @Action("saveAddressBookContact") actionSave: any;
  @Action("deleteAddressBookContact") actionDelete: any;
  @Action("actionLog") actionLog: any;

  logObject: ActionLog = {}
  private item:AddressBookContactItem=Object.create({})
  private itemSaved:AddressBookContactItem=Object.create({})

  async created() {
    if (this.$route.params.contactId) {
      const data = this.addressBookContactsResponse
          .find((blc:AddressBookContactItem) => blc.id?.toString() === this.$route.params.contactId)
      if (data) {
        this.item = Object.assign({},this.item, data);
        this.itemSaved = cloneDeep(Object.assign({},this.item, data));
      }
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: "Contact",
        addititionalInfo: getTranslatedParams({id: this.$route.params.contactId, groupId: this.addressBookItem?.name})
      }
      await this.actionLog(this.logObject)
    }
  }

  back() {
    this.$router.push(`/address_book/group/${this.$route.params.id}/contact`);
  }

  onSaveItem():Promise<void> {
    return new Promise( async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: this.$route.params.contactId ? "Editing" : "Creation",
          actionStatus: 'success',
          objectType: "Contact",
          addititionalInfo: getTranslatedParams(
            {...this.item, id: this.$route.params.contactId, groupId: this.addressBookItem?.name},
            {name: 'firstname'}
          )
        }
        await this.actionSave({
          id: this.$route.params.contactId,
          groupId: this.$route.params.id,
          ...this.item
        });
        this.itemSaved = cloneDeep(this.item);
        await this.actionLog(this.logObject)
        resolve();
        this.back();
      } catch (error) {
        notifyError(error);
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
        reject()
      }
    })
  }

  async onDeleteItem():Promise<void> {
    if (!await notifyDelete()) return
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Removal",
        actionStatus: 'success',
        objectType: "Contact",
        addititionalInfo: getTranslatedParams({id: this.$route.params.contactId, groupId: this.addressBookItem?.name})
      }
      await this.actionDelete({
        contactIds: [this.$route.params.contactId],
      })
      this.itemSaved = this.item;
      await this.actionLog(this.logObject)
      this.back();
    } catch (error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  beforeRouteLeave(to:any, from:any, next:any) {
    let isChange = !isEqual(this.item,this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
}
